export const GENDERS = {
    f: 'Женский',
    m: 'Мужской',
    none: undefined,
};

export const ANALYTICS_FORM_FIELDS = {
    gender: {
        placeholder: 'Пол',
    },
    sopdConfirmed: {
        placeholder: 'Лицензионное соглашение',
    },
};
